// extracted by mini-css-extract-plugin
export default {"header":"Header_header__XZa5K","menu":"Header_menu__lhE6K","content":"Header_content__R0RFN"};